"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
var _toConsumableArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/web.dom.iterable");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _sortablejs = _interopRequireDefault(require("sortablejs"));
var _menuTemplate = require("@/api/goods/menuTemplate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'GroupSort',
  props: {
    templateId: {
      type: Number,
      required: true
    },
    templateName: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      currentScene: 1,
      loading: false,
      configList: [],
      defaultSortConfig: null,
      isSortingDefault: false,
      groupMap: {},
      dialogVisible: false,
      dialogForm: {
        id: null,
        beginTime: null,
        endTime: null
      },
      dialogRules: {
        beginTime: [{
          required: true,
          message: '请选择开始时间',
          trigger: 'change'
        }],
        endTime: [{
          required: true,
          message: '请选择结束时间',
          trigger: 'change'
        }]
      },
      editingConfigId: null,
      // 记录当前编辑的配置ID，用于冲突验证时排除自身
      sortDialogVisible: false,
      sortList: [],
      currentSortConfig: null,
      sortableInstance: null
    };
  },
  created: function created() {
    this.loadData();
  },
  methods: {
    loadData: function () {
      var _loadData = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this = this;
        var defaultRes, res, groupRes, groups, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.templateId) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return");
            case 1:
              this.loading = true;
              _context.prev = 2;
              _context.next = 3;
              return (0, _menuTemplate.getDefaultGroupSort)(this.templateId, this.currentScene);
            case 3:
              defaultRes = _context.sent;
              if (defaultRes.code === 200 || defaultRes.code === 0) {
                this.defaultSortConfig = defaultRes.data || null;
              }

              // 加载时段配置列表
              _context.next = 4;
              return (0, _menuTemplate.getGroupSortList)(this.templateId, this.currentScene);
            case 4:
              res = _context.sent;
              if (res.code === 200 || res.code === 0) {
                this.configList = res.data || [];
              }

              // 加载分组信息用于显示名称
              _context.next = 5;
              return (0, _menuTemplate.getTemplateDishGroup)({
                templateId: this.templateId,
                scene: this.currentScene
              });
            case 5:
              groupRes = _context.sent;
              if (groupRes.code === 200 || groupRes.code === 0) {
                groups = groupRes.data || [];
                this.groupMap = {};
                groups.forEach(function (group) {
                  _this.groupMap[group.groupId] = group.groupName;
                });
              }
              _context.next = 7;
              break;
            case 6:
              _context.prev = 6;
              _t = _context["catch"](2);
              this.$message.error('加载数据失败');
              console.error(_t);
            case 7:
              _context.prev = 7;
              this.loading = false;
              return _context.finish(7);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 6, 7, 8]]);
      }));
      function loadData() {
        return _loadData.apply(this, arguments);
      }
      return loadData;
    }(),
    handleSceneChange: function handleSceneChange() {
      this.loadData();
    },
    handleAddConfig: function handleAddConfig() {
      var _this2 = this;
      this.dialogForm = {
        id: null,
        beginTime: null,
        endTime: null
      };
      this.editingConfigId = null;
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this2.$refs.dialogFormRef.clearValidate();
      });
    },
    handleEditConfig: function handleEditConfig(row) {
      var _this3 = this;
      this.dialogForm = {
        id: row.id,
        beginTime: new Date(row.beginTime).getTime(),
        endTime: new Date(row.endTime).getTime()
      };
      this.editingConfigId = row.id;
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this3.$refs.dialogFormRef.clearValidate();
      });
    },
    // 验证时间冲突
    validateTimeConflict: function validateTimeConflict(beginTime, endTime) {
      var excludeId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var newBegin = new Date(beginTime).getTime();
      var newEnd = new Date(endTime).getTime();

      // 检查开始时间是否小于结束时间
      if (newBegin >= newEnd) {
        this.$message.warning('开始时间必须小于结束时间');
        return false;
      }

      // 检查是否与现有时间段冲突
      var hasConflict = this.configList.some(function (config) {
        // 排除当前编辑的配置
        if (excludeId && config.id === excludeId) {
          return false;
        }
        var existingBegin = new Date(config.beginTime).getTime();
        var existingEnd = new Date(config.endTime).getTime();

        // 判断两个时间段是否重叠
        // 重叠条件：!(新结束时间 <= 现有开始时间 || 新开始时间 >= 现有结束时间)
        var isOverlap = !(newEnd <= existingBegin || newBegin >= existingEnd);
        return isOverlap;
      });
      if (hasConflict) {
        this.$message.warning('该时间段与现有时间段冲突，请重新选择');
        return false;
      }
      return true;
    },
    handleSaveConfig: function handleSaveConfig() {
      var _this4 = this;
      this.$refs.dialogFormRef.validate(/*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          var beginTime, endTime, data, res, _t2;
          return regeneratorRuntime.wrap(function (_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                if (valid) {
                  _context2.next = 1;
                  break;
                }
                return _context2.abrupt("return");
              case 1:
                beginTime = new Date(_this4.dialogForm.beginTime);
                endTime = new Date(_this4.dialogForm.endTime); // 验证时间冲突
                if (_this4.validateTimeConflict(beginTime, endTime, _this4.dialogForm.id)) {
                  _context2.next = 2;
                  break;
                }
                return _context2.abrupt("return");
              case 2:
                data = {
                  templateId: _this4.templateId,
                  scene: _this4.currentScene,
                  beginTime: beginTime,
                  endTime: endTime
                };
                _context2.prev = 3;
                if (!_this4.dialogForm.id) {
                  _context2.next = 5;
                  break;
                }
                data.id = _this4.dialogForm.id;
                _context2.next = 4;
                return (0, _menuTemplate.updateGroupSortConfig)(data);
              case 4:
                res = _context2.sent;
                _context2.next = 7;
                break;
              case 5:
                _context2.next = 6;
                return (0, _menuTemplate.createGroupSortConfig)(data);
              case 6:
                res = _context2.sent;
              case 7:
                if (res.code === 200 || res.code === 0) {
                  _this4.$message.success('保存成功');
                  _this4.dialogVisible = false;
                  _this4.loadData();
                }
                // 错误提示已在响应拦截器中统一处理，此处无需再提示
                _context2.next = 9;
                break;
              case 8:
                _context2.prev = 8;
                _t2 = _context2["catch"](3);
                console.error(_t2);
              case 9:
              case "end":
                return _context2.stop();
            }
          }, _callee2, null, [[3, 8]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    handleDeleteConfig: function handleDeleteConfig(row) {
      var _this5 = this;
      this.$confirm('确认删除该配置吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 1;
              return (0, _menuTemplate.deleteGroupSortConfig)(row.id);
            case 1:
              res = _context3.sent;
              if (res.code === 200 || res.code === 0) {
                _this5.$message.success('删除成功');
                _this5.loadData();
              }
              // 错误提示已在响应拦截器中统一处理，此处无需再提示
              _context3.next = 3;
              break;
            case 2:
              _context3.prev = 2;
              _t3 = _context3["catch"](0);
              console.error(_t3);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 2]]);
      })));
    },
    handleSortDefaultGroups: function handleSortDefaultGroups() {
      var _this6 = this;
      if (!this.defaultSortConfig) {
        this.$message.warning('暂无默认排序数据');
        return;
      }
      this.isSortingDefault = true;
      this.currentSortConfig = this.defaultSortConfig;
      this.sortList = this.defaultSortConfig.details ? (0, _toConsumableArray2.default)(this.defaultSortConfig.details) : [];
      this.sortDialogVisible = true;
      this.$nextTick(function () {
        _this6.initSortable();
      });
    },
    handleSortGroups: function handleSortGroups(row) {
      var _this7 = this;
      this.isSortingDefault = false;
      this.currentSortConfig = row;
      this.sortList = row.details ? (0, _toConsumableArray2.default)(row.details) : [];
      this.sortDialogVisible = true;
      this.$nextTick(function () {
        _this7.initSortable();
      });
    },
    initSortable: function initSortable() {
      var _this8 = this;
      var el = this.$refs.sortList;
      if (!el) return;
      if (this.sortableInstance) {
        this.sortableInstance.destroy();
      }
      this.sortableInstance = new _sortablejs.default(el, {
        animation: 200,
        handle: '.sort-handle',
        onEnd: function onEnd(evt) {
          var oldIndex = evt.oldIndex,
            newIndex = evt.newIndex;
          var item = _this8.sortList.splice(oldIndex, 1)[0];
          _this8.sortList.splice(newIndex, 0, item);
        }
      });
    },
    handleSortDialogClosed: function handleSortDialogClosed() {
      if (this.sortableInstance) {
        this.sortableInstance.destroy();
        this.sortableInstance = null;
      }
    },
    handleSaveSort: function () {
      var _handleSaveSort = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var detailIds, res, _t4;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              detailIds = this.sortList.map(function (item) {
                return item.id;
              });
              _context4.prev = 1;
              _context4.next = 2;
              return (0, _menuTemplate.saveGroupSortConfig)({
                ids: detailIds
              });
            case 2:
              res = _context4.sent;
              if (res.code === 200 || res.code === 0) {
                this.$message.success('保存成功');
                this.sortDialogVisible = false;
                this.loadData();
              }
              // 错误提示已在响应拦截器中统一处理，此处无需再提示
              _context4.next = 4;
              break;
            case 3:
              _context4.prev = 3;
              _t4 = _context4["catch"](1);
              console.error(_t4);
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[1, 3]]);
      }));
      function handleSaveSort() {
        return _handleSaveSort.apply(this, arguments);
      }
      return handleSaveSort;
    }(),
    formatTime: function formatTime(timestamp) {
      if (!timestamp) return '-';
      var date = new Date(timestamp);
      var hours = String(date.getHours()).padStart(2, '0');
      var minutes = String(date.getMinutes()).padStart(2, '0');
      return "".concat(hours, ":").concat(minutes);
    },
    getGroupName: function getGroupName(groupId) {
      return this.groupMap[groupId] || '未知分组';
    }
  }
};